import './heading.css';

const Heading = ({ title , subTitle }) => {
    return (
        <div className='w-full flex flex-col items-center justify-center gap-6 text-center'>
            <div className='main-heading relative text-center w-fit '>
                <h1 className='font-semibold sm:text-3xl text-2xl flex items-center gap-2'>
                    {title}
                </h1>
            </div>
            { subTitle && <p>{subTitle}</p> }
        </div>
    )
}

export default Heading